import { render, staticRenderFns } from "./KongsbergLogo.vue?vue&type=template&id=b2fae0c4&"
import script from "./KongsbergLogo.vue?vue&type=script&lang=js&"
export * from "./KongsbergLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports